import { CameraPreset } from '@/types/camera.types';

/**
 * Predefined camera views for different holes
 * These presets are used to automatically position the camera
 */
export const cameraPresets: Record<string, CameraPreset> = {
  default: {
    position: {
      x: 4.679680708765267,
      y: 473.8385595371528,
      z: -52.85923533019707,
    },
    target: {
      x: 4.376134006926391,
      y: -66.7120384881958,
      z: -66.86236825275098,
    },
  },
  hole1: {
    position: {
      x: -459.64966845798557,
      y: 368.96522544500937,
      z: -41.734934155690055,
    },
    target: {
      x: -256.3995188470189,
      y: -55.83519280523459,
      z: -34.64490639568447,
    },
  },
  hole2a: {
    position: {
      x: -357.6720590034332,
      y: 102.74327059169008,
      z: -37.58371050837515,
    },
    target: {
      x: -108.66666731822193,
      y: -82.24160826526284,
      z: -102.17666399550738,
    },
  },
  hole2: {
    position: {
      x: -66.8723520558227,
      y: 216.44763644288093,
      z: 53.89956332319528,
    },
    target: {
      x: -92.72370373115534,
      y: -65.86583722318409,
      z: -87.61421811654944,
    },
  },
  hole3: {
    position: {
      x: 102.29860360595546,
      y: 177.26215942154874,
      z: 488.987402257183,
    },
    target: {
      x: 155.37930914454876,
      y: -251.56101874638642,
      z: 156.6074124368279,
    },
  },
  hole4: {
    position: {
      x: 316.8546449731248,
      y: 284.3525854335958,
      z: 352.14569418657914,
    },
    target: {
      x: 106.83963799641693,
      y: -178.78296792792412,
      z: 120.85078140472164,
    },
  },
};
